import { Badge } from '@themesberg/react-bootstrap';
import React from 'react';
import { getTripBadgeStatus } from '../../utils/trips';
import ActionButton from '../oms/interBranchTransfers/components/ActionButton';

export const returnVendorListTableColumns = (handleSelectedRowUpdate) => {
  return [
    {
      dataField: 'objectId',
      text: 'Action',
      formatter: (cell, row) => (
        <ActionButton
          options={['Edit', 'Activate', 'Deactivate']}
          onActionClick={(option) => handleSelectedRowUpdate(option, row)}
        />
      ),
    },
    {
      dataField: 'vendorName',
      sort: true,
      text: 'Vendor Info',
      formatter: (cell, row) => {
        return (
          <div className="d-block">
            <span className="fw-bold">{cell}</span>
            <div className="fw-normal">{row?.vendorCode}</div>
          </div>
        );
      },
    },
    {
      dataField: 'contactNumber',
      text: 'Contact Info',
      formatter: (cell, row) => {
        return (
          <div className="d-block">
            <span className="fw-bold">{cell}</span>
            <div className="fw-normal">{row?.emailId}</div>
          </div>
        );
      },
    },
    {
      dataField: 'gstNumber',
      text: 'GST Number',
      formatter: (cell, row) => {
        return (
          <div className="d-block">
            <span className="fw-bold">{cell}</span>
          </div>
        );
      },
    },
    {
      dataField: 'branch',
      text: 'Branch',
      formatter: (cell, row) => {
        return (
          <div className="d-block">
            <span className="fw-bold">{cell}</span>
          </div>
        );
      },
    },
    {
      dataField: 'zone',
      text: 'Zone',
      formatter: (cell, row) => {
        return (
          <div className="d-block">
            <span className="fw-bold">{cell}</span>
          </div>
        );
      },
    },
    {
      dataField: 'status',
      text: 'Status',
      formatter: (cell, row) => {
        return (
          <div className="d-block">
            <div className="fw-bold">
              <span>
                &nbsp;&nbsp;
                <Badge bg={getTripBadgeStatus(cell)} className="badge-lg">
                  {cell}
                </Badge>{' '}
                &nbsp;&nbsp;
              </span>
            </div>
            <span className="fw-normal">{row?.tripInfo?.vehicleNumber}</span>
          </div>
        );
      },
    },
  ];
};
